import { Tooltip } from '@mui/material'
import React, { CSSProperties, useMemo } from 'react'
import { smallCageLabelFontSize } from '../constraints'

type CageLabelProps = {
  text: string
  color: string
  fontSize: number
  maxLength?: number
  bold?: boolean
  isSmallMapView?: boolean
}

function getDisplayText(text: string, maxLength?: number, ellipsis = '...') {
  if (maxLength == null || text.length <= maxLength) return { display: text, truncated: false }
  const remainder = text.slice(maxLength).trim()
  // Match DynamicTextTypography: only truncate when more than one leftover character/word remains.
  if (!remainder || remainder.length <= 1) return { display: text, truncated: false }
  return { display: text.slice(0, maxLength) + ellipsis, truncated: true }
}

export const CageLabel: React.FC<CageLabelProps> = ({
  text,
  color,
  fontSize,
  maxLength,
  bold = false,
  isSmallMapView = false,
}) => {
  const { display, truncated } = useMemo(() => getDisplayText(text, maxLength), [text, maxLength])

  const style: CSSProperties = {
    display: 'block',
    fontSize: isSmallMapView ? smallCageLabelFontSize : fontSize,
    fontWeight: bold ? 600 : undefined,
    color,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    textAlign: 'center',
    margin: 0,
    padding: 0,
  }

  const label = (
    <strong data-test-id="map-cage-label" style={style}>
      {display}
    </strong>
  )

  if (truncated) {
    return (
      <Tooltip title={text}>
        <span style={{ display: 'block', lineHeight: 1 }}>{label}</span>
      </Tooltip>
    )
  }

  return label
}
